module.exports = __webpack_public_path__ + "static/media/createResolution.ea99ef4c.svg";